import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IUpdateToastAutoDismissParams {
  timeout: number;
}

export class UpdateToastAutoDismissRequest extends Request<IUpdateToastAutoDismissParams, IResult> {
  constructor(params: IUpdateToastAutoDismissParams) {
    super('updateToastAutoDismissSetting', params);
  }
}
